import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FilterAltOffSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FilterAltOffSVG;
